import { Injectable } from '@angular/core';
import { Driver } from '../../shared/models/admin/driver';
import { HttpClientService } from '../../core/http-client/http-client.service';
import { Observable } from 'rxjs';
import { featureTogglingConfig } from '@app/shared/constants/feature.config';


@Injectable({
  providedIn: 'root'
})
export class ManageDriverService {

  private static readonly endpoint = featureTogglingConfig.resources.pages['manage-drivers'].concierge ? 'Driver' : 'DriverExpress';


  constructor(private http: HttpClientService) { }

  /**
   * Driver details
   *
   *
   * @param id
   */
  get(id: number) {
    return this.http.get<Driver>(`${ManageDriverService.endpoint}/Details/${id}`);
  }

  /**
   * has Any Active Workorders
   * 
   */
  hasAnyActiveWorkorders(driverId: number) {
    return this.http.get<boolean>(`${ManageDriverService.endpoint}/HasAnyActiveWorkorders/${driverId}`);
  }

  /**
   * All Drivers
   * 
   * 
   * @returns 
   */
  list() {
    return this.http.get<Driver[]>(`${ManageDriverService.endpoint}/GetAll`);
  }

  getAllDrivers() {
    return this.http.get<any[]>(`${ManageDriverService.endpoint}/GetAllDrivers`);
  }

  driversBySectorId(sectorId: number) {
    return this.http.get<Driver[]>(`${ManageDriverService.endpoint}/GetAllByServiceSector/${sectorId}`);
  }

  GetAllByServiceSector
  /**
   * Paginationed drivers list
   *
   *
   * @param body
   */
  listByPagination(body: any): Observable<Driver[]> {
    return this.http.post<Driver[]>(body, `${ManageDriverService.endpoint}/GetAllByPagination`);
  }

  changePassword(body: any): Observable<any> {
    return this.http.post<any>(body, `${ManageDriverService.endpoint}/ChangePassword`);
  }

  /**
   * Add new manager
   *
   *
   * @param model
   */
  create(model: Object): Observable<Driver> {
    return this.http.postFormData(model, `${ManageDriverService.endpoint}/Create`);
  }

  /**
   * Update current driver
   *
   *
   * @param driverId
   * @returns {Observable}
   */
  update(model: Object): Observable<Driver> {
    return this.http.postFormData<Driver>(model, `${ManageDriverService.endpoint}/Update`);
  }

  /**
   * Delete Driver
   *
   *
   * @param driverId
   */
  delete(driverId: number) {
    return this.http.delete<boolean>(`${ManageDriverService.endpoint}/Delete/${driverId}`);
  }

  /**
   * to excel
   * 
   * 
   * @param body 
   * @returns 
   */
  exportToExcel(body: object) {
    return this.http.getForDownloadFile<Blob>(`${ManageDriverService.endpoint}/ExportToExcel`, { responseType: 'blob' }, body);
  }

  getDriversCount() {
    return this.http.get(`${ManageDriverService.endpoint}/GetDriversCount`);
  }
}
